export default [
  {
    path: "/transfers",
    component: () => import(/* webpackChunkName: "transfers" */ "./layout"),

    children: [
      {
        path: "/",
        name: "transfers.index",
        component: () => import(/* webpackChunkName: "transfers.index" */ "./all"),
      },
      {
        path: "accounting",
        name: "transfers.accounting",
        component: () => import(/* webpackChunkName: "transfers.accounting" */ "./accounting"),
      },
      {
        props: true,
        path: ":id",
        name: "transfers.show",
        component: () => import(/* webpackChunkName: "transfers.show" */ "./show"),
      },
    ],
  },
];
